import Racks from "@v2/components/racks";

export default Racks;
